export default __webpack_public_path__ + "static/user-img-1-49a231a58d177a3c977ed2d08ebd7912.png";